import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import DatePicker from "react-datepicker";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import PeopleReviewedList from "../Components/PeopleReviewedList";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import "./PerformanceReview.css";

function PerformanceReview() {
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [dueDate, setDueDate] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [selectedOption, setSelectedOption] = useState(null);
  const [peopleReviewed, setPeopleReviewed] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/objectives/available/reviewers/${state.userId}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setUsers(response.data.users);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, state.userId]);

  const handleSubmit = async () => {
    if (!selectedOption || selectedOption.length === 0) {
      handleShowModal();
      return;
    }
    setIsLoading(true);
    const response = await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/objectives/review`,
      data: {
        users: selectedOption,
        startDate: startDate,
        dueDate: dueDate,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    setPeopleReviewed(response.data.peopleReviewed);
    setIsLoading(false);
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container>
        <Row>
          <Col>
            <h1>{t("Objetivos.PerformanceReview.Titulo")}</h1>
          </Col>
        </Row>
        <Col className="inputContainer">
          <Row className="justify-content-center align-items-center">
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("Objetivos.PerformanceReview.FechaInicio")}
                </Form.Label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("Objetivos.PerformanceReview.FechaTermino")}
                </Form.Label>
                <DatePicker
                  selected={dueDate}
                  onChange={(date) => setDueDate(date)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="justify-content-center align-items-center">
            <Col lg={11}>
              <Form.Group className="mb-3">
                <Form.Label>
                  {t("Objetivos.PerformanceReview.SeleccionarUsuarios")}
                </Form.Label>
                <Select
                  isMulti
                  isSearchable
                  closeMenuOnSelect={false}
                  value={selectedOption}
                  onChange={setSelectedOption}
                  options={users}
                />
              </Form.Group>
            </Col>
            <Col lg={1} className="right">
              <Button className="primary" onClick={handleSubmit}>
                {t("Objetivos.PerformanceReview.Consultar")}
              </Button>
            </Col>
          </Row>
        </Col>
        <Col>
          {peopleReviewed.length > 0 && (
            <PeopleReviewedList peopleReviewed={peopleReviewed} />
          )}
        </Col>
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {t("Objetivos.PerformanceReview.SinUsuariosSeleccionados")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {t("Objetivos.PerformanceReview.SinUsuariosSeleccionadosMensaje")}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              {t("Objetivos.PerformanceReview.Ok")}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  }
}

export default PerformanceReview;
